<template>
  <Modal
    fullscreen
    :title="'Histórico de Alterações'"
    :active="active"
    @close="closeModal()"
    data-testId="change-historic-popup"
  >
    <h3 class="mb-6">Proposta {{ proposalId }}</h3>
    <div class="table-container">
      <vs-table
        noDataText="Sem Alterações"
        ref="table"
        stripe
        search
        :data="logs"
      >
        <template slot="thead">
          <vs-th style="width: 10%" sort-key="createdAt" class="uppercase"
            >Data e Hora
          </vs-th>
          <vs-th style="width: 20%" sort-key="user" class="uppercase"
            >Responsável
          </vs-th>
          <vs-th style="width: 20%" sort-key="campo" class="uppercase"
            >Campo alterado
          </vs-th>
          <vs-th style="width: 25%" sort-key="dadoOld" class="uppercase"
            >Dado anterior
          </vs-th>
          <vs-th style="width: 25%" sort-key="dadoNew" class="uppercase"
            >Dado posterior
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr v-for="(item, index) in data" :key="index">
              <vs-td style="width: 10%">
                {{ item.createdAt }}
              </vs-td>
              <vs-td style="width: 20%">
                <p v-if="item.userId">
                  {{ item.userId }} - {{ item.userName }}
                </p>
                <p v-else>System</p>
              </vs-td>
              <vs-td style="width: 20%">
                <p>{{ mapFieldName(item) }}</p>
              </vs-td>

              <vs-td style="width: 25%">
                <div class="data-text">
                  {{ getOldDataText(item) }}
                </div>
              </vs-td>
              <vs-td style="width: 25%">
                <div class="data-text">
                  {{ getNewDataText(item) }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal.vue';
import {
  MAP_PAYMENT_METHODS,
  MAP_POLICY_STATUSES,
  MAP_PROPOSAL_STATUSES,
  MAP_REASONS_REFUSING_PROPOSAL,
} from '@/utils/constants';
import historyApi from '@/services/history.api';
import moment from 'moment/moment';
import {
  DATE_FIELDS,
  EXCLUDED_FIELDS,
  TRANSLATED_DRIVER_FIELDS,
  TRANSLATED_INSURED_FIELDS,
  TRANSLATED_POLICY_FIELDS,
  TRANSLATED_PROPOSAL_FIELDS,
} from '@/utils/translatedProposalFields';

export default {
  name: 'ModalProposalHistory',
  components: {
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    proposalId: {
      type: Number,
      required: true,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldsNames: {
        propostas: TRANSLATED_PROPOSAL_FIELDS,
        apolices: TRANSLATED_POLICY_FIELDS,
        associados: TRANSLATED_INSURED_FIELDS,
        drivers: TRANSLATED_DRIVER_FIELDS,
      },
      statusesNames: MAP_PROPOSAL_STATUSES,
      policyStatusNames: MAP_POLICY_STATUSES,
      paymentMethodsNames: MAP_PAYMENT_METHODS,
      refusalReasonsNames: MAP_REASONS_REFUSING_PROPOSAL,
      logs: [],
    };
  },
  created() {
    this.getLogs();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          this.logs = [];
          await this.getLogs();
          this.$emit('update:refresh');
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    mapFieldName(item) {
      const fieldsNames =
        this.fieldsNames[String(item.table).toLocaleLowerCase()];
      return fieldsNames[item.field] || item.field;
    },
    getStatusName(statusId) {
      return this.statusesNames[statusId] || statusId;
    },
    getPolicyStatusName(statusId) {
      return this.policyStatusNames[statusId] || statusId;
    },
    getPaymentMethodName(paymentMethodId) {
      return this.paymentMethodsNames[paymentMethodId];
    },
    getOldDataText(item) {
      if (item.field === 'id_Status') {
        return this.getStatusName(item.oldData);
      }
      if (item.field === 'idStatusApolice') {
        return this.getPolicyStatusName(item.oldData);
      }
      if (item.field === 'id_motivo_recusa') {
        return this.getRefusalReasonsName(item.oldData);
      }
      if (item.field === 'id_tipo_pagamento') {
        return this.getPaymentMethodName(item.oldData);
      }
      return item.oldData || '-';
    },
    getNewDataText(item) {
      if (item.field === 'id_Status') {
        return this.getStatusName(item.newData);
      }
      if (item.field === 'idStatusApolice') {
        return this.getPolicyStatusName(item.newData);
      }
      if (item.field === 'id_motivo_recusa') {
        return this.getRefusalReasonsName(item.newData);
      }
      if (item.field === 'id_tipo_pagamento') {
        return this.getPaymentMethodName(item.newData);
      }
      return item.newData || '-';
    },
    getRefusalReasonsName(refusalReasonId) {
      return this.refusalReasonsNames[refusalReasonId] || refusalReasonId;
    },
    async getLogs() {
      this.$vs.loading();
      historyApi
        .getProposalHistory(this.proposalId)
        .then((res) => {
          res.map((item) => {
            this.formatStrings(item);
            this.formatDecimalFields(item);
            this.formatPercentageFields(item);
            this.formatMonetaryFields(item);
            this.formatDateFields(item);
            item.createdAt = moment(item.createdAt)
              .utc(true)
              .format('DD/MM/YYYY - HH:mm');
            if (!EXCLUDED_FIELDS.includes(item.field)) {
              this.logs.push(item);
            }
          });
        })
        .catch((error) => {
          console.error(error);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar os logs',
            color: 'danger',
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    formatDecimalFields(item) {
      if (item.oldData && !isNaN(item.oldData) && item.oldData.includes('.')) {
        item.oldData = Number(item.oldData).toFixed(2);
      }
      if (item.newData && !isNaN(item.newData) && item.newData.includes('.')) {
        item.newData = Number(item.newData).toFixed(2);
      }
    },
    formatMonetaryFields(item) {
      if (
        ['valorFinal', 'valor'].includes(item.field.split('- ')[1]) ||
        ['valorCobertura', 'valorParticipacaoMinimo', 'valorFipe'].includes(
          item.field,
        )
      ) {
        item.oldData = `R$ ${item.oldData}`;
        item.newData = `R$ ${item.newData}`;
      }
    },
    formatStrings(item) {
      if (!item.oldData || item.oldData === 'null' || item.oldData === '') {
        item.oldData = '-';
      }
      if (!item.newData || item.newData === 'null' || item.newData === '') {
        item.newData = '-';
      }
      item.oldData = item.oldData.replace(/\\"/g, '').replace(/"/g, '');
      item.newData = item.newData.replace(/\\"/g, '').replace(/"/g, '');
    },
    formatDateFields(item) {
      if (DATE_FIELDS.includes(item.field)) {
        if (item.oldData && item.oldData !== '-') {
          item.oldData = moment(item.oldData).utc().format('DD/MM/YYYY');
        }
        if (item.newData && item.newData !== '-') {
          item.newData = moment(item.newData).utc().format('DD/MM/YYYY');
        }
      }
    },
    formatPercentageFields(item) {
      if (
        item.field.split('- ')[1] === 'descontoConcedido' ||
        item.field === 'valorCotaParticipacao'
      ) {
        item.oldData = `${item.oldData} %`;
        item.newData = `${item.newData} %`;
      }
    },
  },
};
</script>

<style scoped>
.data-text {
  word-break: break-all;
}
</style>
